// extracted by mini-css-extract-plugin
module.exports = {"title":"style__title__EiNbV","wrapper":"style__wrapper__s+Psz"};